import { ProviderCreateDocumentType, SupportDocumentType } from '../../api';

export const MAX_BATCH_UPLOAD_FILES = 1000;
export const DEFAULT_BATCH_UPLOAD_CONCURRENCY = 4;
/**
 * Backend requests per file:
 * OPTIONS+POST /document, OPTIONS+POST /upload, OPTIONS+POST /refresh_metadata, GET /document
 */
export const DOCUMENT_UPLOAD_BACKEND_REQUESTS_PER_FILE = 7;
/** 150 request slots per 1-minute sliding window (well below backend 300/min) */
export const DEFAULT_BATCH_UPLOAD_RATE_LIMIT = 150;
export const RATE_LIMIT_WINDOW_MS = 60_000;
/** Extra wait after the calculated window boundary to avoid resuming too early */
export const RATE_LIMIT_RETRY_BUFFER_MS = 5_000;
/** Global pause after a file upload fails before retrying */
export const UPLOAD_FAILURE_BACKOFF_MS = 120_000;
export const DEFAULT_ACCEPTED_FILE_TYPES = 'application/pdf,image/*';

export type BatchUploadAppType = 'provider' | 'support';

export type UploadStatus = 'pending' | 'uploading' | 'success' | 'failed' | 'cancelled';

export type BatchUploadJobStatus = 'queued' | 'running' | 'paused' | 'completed' | 'cancelled';

export interface FileUploadItem {
    id: string;
    file: File;
    status: UploadStatus;
    documentId?: string;
    errorMessage?: string;
}

export interface BatchUploadMetadata {
    documentType: ProviderCreateDocumentType | SupportDocumentType;
    description?: string;
    claimId?: string;
}

export interface BatchUploadStats {
    total: number;
    success: number;
    failed: number;
    pending: number;
    uploading: number;
    cancelled: number;
}

export interface BatchUploadJob {
    id: string;
    appType: BatchUploadAppType;
    metadata: BatchUploadMetadata;
    items: FileUploadItem[];
    status: BatchUploadJobStatus;
    createdAt: number;
}

export interface BatchUploadFormValues {
    files: File[];
    documentType: ProviderCreateDocumentType | SupportDocumentType | null;
    description?: string;
    claimId?: string;
}

export interface BatchUploadConfig {
    appType: BatchUploadAppType;
    maxFiles?: number;
    maxConcurrent?: number;
    maxRequestsPerMinute?: number;
    acceptedTypes?: string;
}

export interface ICoreBatchUploadStoreConfig {
    maxConcurrent?: number;
    maxRequestsPerMinute?: number;
    onBatchComplete?: (batchId: string, items: FileUploadItem[]) => void;
}

export interface EnqueueBatchOptions {
    onComplete?: (items: FileUploadItem[]) => void;
}
